import axios from 'axios';
import React,{useCallback, useState} from 'react'
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import GlobalFooter from './GlobalFooter';

function CanadaLanding() {
    const record = JSON.parse(localStorage.getItem("auth"))
    const [isLoading,setIsLoading] = useState(false)
    const navigate = useNavigate()
    // const [formData, setFormData] = useState({
    //     phoneCode: '+234',
    //     phoneNumber: ''
    // });
    const { 

        register, 
    
        handleSubmit, 
    
        getValues, 
    
        formState: { errors }, 
    
      } = useForm(); 

      const onSubmit = async (data)=>{
        setIsLoading(true)
        const {email,fullname} = data
        const payload ={
            email: data.email,
            fullname:data.fullname,
            amount:`${record?.data?.amount}` 
        }
        try{
            const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/canada/initiate-transfer"

            const res = await axios.post(url,payload);
            const link = res.data?.data.url
            if(link){
                // const url = `https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/iglobal-payment/canada/payment-status/${id}`
                // console.log(url)
                window.location.href = link;
                setIsLoading(false)
                return
            }else{
                toast.warning("reference id is not valid")
            }

        }catch(err){
            console.log(err)
            setIsLoading(false)
            let expectedError = err?.response
            let errorMessage = ''
            if(expectedError){
                 errorMessage = err?.response?.data?.data?.title || "An error has occured, please try again."
                 toast.error(errorMessage)
            }else{
                toast.error("An error has occured")
            }
        }
      }
      const handleClose = ()=>{
        // navigate('/pages/global-payment')
      }
  return (
    <div className='global_layout'>
        {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
            } */}
    
        <div className='global_container'>
            <div className='top_bar'>
                {/* <img src='/images/global/arrow-left.svg' alt=''/> */}
                <img src='/images/global/close.svg' alt='' style={{marginLeft:"auto"}} onClick={handleClose}/>
            </div>

            <div className='global_content'>
                <div className='glob_avater'>
                        {
                            record?.avatar ?
                            
                            <img className='img_avater' src={record?.avatar} alt='' style={{width:"58px",height:"58px"}}/>:
                            
                            <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0,1)}</p>
                        }
                </div>
                <p className='glob_title'>Payment information</p>
                <p className='glob_desc'>Your data is encrypted and your details will not be accessible to Superwallet</p>
                <div className='amount_content'>
                    <div className='name_amount'>
                        <img src='/images/global/briefcase.svg' alt=''/> 
                        <p className='glob_name'>Name</p>
                    </div>
                    <h6 className='name_value'>{record?.data?.business_name}</h6>
                </div>
                <div className='amount_pattern'>
                    <p className='glob_name' style={{marginTop:"10px"}}>Amount</p>
                    <p className='glob_amount_value'>{record?.payableFxAmountString}</p>
                </div>
                {/* Phone Number */}
                <form className='glob_form' onSubmit={handleSubmit(onSubmit)}>
                    <div className='phone_container' style={{display:"flex",flexDirection:"column",gap:"10px"}}>
                        <div style={{display:"flex"}}>
                            <label className='input_lbl' htmlFor="fullname">FullName</label> 
                            {/* <p className='glob_name'>Phone</p> */}
                            <img src='/images/global/asterisk.svg' alt=''/>
                        </div>
                        {/* input field */}
                        <div> 

                            <input 

                            placeholder="Fullname" 
                            className='input_field'
                            {...register("fullname", { required: true})} 

                            /> 

                        </div> 
                        {/* Error message */}
                        {errors.fullname && <p className='error_msg' style={{ color: '#D92D20', marginTop: '5px' }}>Fullname is required.</p>}

                        <div style={{display:"flex"}}>
                            <label className='input_lbl' htmlFor="email">Email</label> 
                            {/* <p className='glob_name'>Phone</p> */}
                            <img src='/images/global/asterisk.svg' alt=''/>
                        </div>
                        {/* input field */}
                        <div> 

                            <input 
                            className='input_field'
                            placeholder="Email" 

                            {...register("email", { 
                                required: true,
                                pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
                            })} 
                            
                            /> 

                        </div> 
                        {/* Error message */}
                        {errors.email && <p className='error_msg' style={{ color: '#D92D20', marginTop: '5px' }}>Email is required.</p>}
                        {/* {errorMessage && (
                                <p className='error_msg' style={{ color: '#D92D20', marginTop: '5px' }}>{errors.firstname?.message}</p>
                        )} */}
                    </div>

                    <p className='instruction_text' style={{marginTop:"18px"}}>By selecting “Continue” you agree to the </p>
                    <h5 className='flick_privacy'>Flick End User Privacy Policy</h5>
                    <button 
                     disabled={ isLoading}
                     type='submit'
                     className={`${ isLoading ? 'unactive' : 'globalBtn'}`}
                   
                    style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"18px",gap:"8px"}}
                    >
                        {isLoading ? (
                            <BeatLoader
                                color="#FFF"
                                cssOverride={{}}
                            />              ) : (
                            <>   
                                <p>Proceed</p>
                                {
                                     isLoading ?
                                    <img src='/images/global/inactive.svg' alt='' />:
                                    <img src='/images/global/activeArrow.svg' alt='' />
                                }
                            </>
                        )}   
                    </button>
                </form>

            </div>
        </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default CanadaLanding